var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.555,
    height: 11.688,
    viewBox: "0 0 40.555 11.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "back",
    d: "M1.016,0V-11.375H5a5.232,5.232,0,0,1,3.141.793,2.712,2.712,0,0,1,1.07,2.324,2.57,2.57,0,0,1-.43,1.473,2.482,2.482,0,0,1-1.2.934,2.4,2.4,0,0,1,1.379.883,2.61,2.61,0,0,1,.5,1.625A3,3,0,0,1,8.422-.859,4.713,4.713,0,0,1,5.438,0ZM3.359-4.953v3.07H5.367A1.938,1.938,0,0,0,6.66-2.277a1.353,1.353,0,0,0,.465-1.09A1.428,1.428,0,0,0,5.508-4.953Zm0-1.656H5.094q1.773-.031,1.773-1.414a1.307,1.307,0,0,0-.449-1.113A2.363,2.363,0,0,0,5-9.477H3.359ZM17.648-2.344H13.539L12.758,0H10.266L14.5-11.375h2.172L20.93,0H18.438Zm-3.477-1.9h2.844L15.586-8.5Zm16.586.453A4.025,4.025,0,0,1,29.4-.9,4.76,4.76,0,0,1,26.18.156a4.28,4.28,0,0,1-3.441-1.473,6.038,6.038,0,0,1-1.254-4.043v-.7a6.819,6.819,0,0,1,.578-2.891,4.332,4.332,0,0,1,1.652-1.918,4.629,4.629,0,0,1,2.5-.668,4.637,4.637,0,0,1,3.172,1.055,4.326,4.326,0,0,1,1.391,2.961H28.43a2.376,2.376,0,0,0-.613-1.6,2.271,2.271,0,0,0-1.605-.5,1.991,1.991,0,0,0-1.754.84,4.707,4.707,0,0,0-.6,2.605V-5.3a5.038,5.038,0,0,0,.559,2.7,1.954,1.954,0,0,0,1.762.852,2.314,2.314,0,0,0,1.621-.5,2.241,2.241,0,0,0,.613-1.535Zm5.1-.773L34.641-3.25V0H32.3V-11.375h2.344v5.156l1.031-1.414,2.9-3.742h2.883L37.414-6.32,41.57,0H38.781Z",
    transform: "translate(-1.016 11.531)",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.d3103c38eb87404e04a788c0bf3829d3.svg";
export { ForwardRef as ReactComponent };